import { BaseLog, BaseLogArgs } from './BaseLog';
import { LEVEL } from './LEVEL';

export function BetslipLog({ message, data = {}, stacktrace, level = LEVEL.INFO }: Partial<BaseLogArgs>) {
    return BaseLog({
        category: 'BETSLIP',
        message,
        data,
        level,
        stacktrace
    });
}
